import { Box, SxProps, Tooltip, TooltipProps } from "@mui/material";

import { PartialBy } from "@app/common/types";

export interface TooltipWrapperProps extends PartialBy<TooltipProps, "title"> {
  /** Condition to show the tooltip wrapper. This prop can be used instead of conditionally passing a title */
  show?: boolean;
  title?: TooltipProps["title"]; // allow title to be optional
  wrapperSx?: SxProps;
}

/**
 * Wrapper component to conditionally render a tooltip; adds a span between the tooltip
 * and the child to ensure that the tooltip has something to attach to
 * */
const TooltipWrapper = ({
  arrow = true,
  children,
  show = true,
  title,
  wrapperSx,
  ...tooltipProps
}: TooltipWrapperProps) => {
  if (title && show) {
    return (
      <Tooltip arrow={arrow} title={title} {...tooltipProps}>
        <Box
          component="span"
          sx={{ width: "fit-content", maxWidth: "100%", ...wrapperSx }}
        >
          {children}
        </Box>
      </Tooltip>
    );
  }

  return children;
};

export default TooltipWrapper;
